import { Directive, ElementRef, inject, Input, type OnInit } from '@angular/core';

@Directive({
  selector: '[autofocusIf]',
})
export class AutofocusIfDirective implements OnInit {
  private el = inject(ElementRef);

  @Input() autofocusIf: boolean;

  ngOnInit() {
    if (this.autofocusIf) {
      // focus event could cause a blur from a previously focused event, that will update ng-touched
      // wrap in timeout to prevent ExpressionChanged....
      setTimeout(() => this.el.nativeElement.focus());
    }
  }
}
